import type { CSSProperties } from 'react';

interface IconProps {
  name: string;
  size?: number;
  fill?: 0 | 1;
  color?: string;
  style?: CSSProperties;
}

// Material Symbols Outlined glyph. Matches the prototype's
// `font-family:'Material Symbols Outlined'` spans.
export function Icon({ name, size = 20, fill = 0, color, style }: IconProps) {
  return (
    <span
      className="ms"
      style={{
        fontFamily: "'Material Symbols Outlined'",
        fontSize: size,
        color,
        flex: '0 0 auto',
        fontVariationSettings: `'FILL' ${fill}`,
        ...style,
      }}
    >
      {name}
    </span>
  );
}
